import { useRef, useContext } from 'react';
import { Button, Dialog, DialogContent, Typography, CircularProgress, InputAdornment } from '@mui/material';
import { Box } from '@mui/system';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { TextField } from 'formik-mui';

import { GET_CARDS } from 'context/cards/types';
import { Cards } from 'lib/api';
import { CardContext } from 'context/cards/cardContext';
import SnackBarComponent from 'components/shared/SnackBarComponent';

const ReplenishModal = ({ cardId, card, open, setOpen }) => {
    const initialValues = {
        amount: card?.balance
    };
    const { dispatch } = useContext(CardContext);
    const snackBarRef = useRef();

    const replenishSchema = Yup.object().shape({
        amount: Yup.number()
            .typeError('Invalid Amount')
            .positive('Invalid amount')
            .required('Required')
            .test(
                'isAmountValid',
                `Should be less or equal to ${card?.limitAmount - card?.balance}`,
                amount => amount <= card?.limitAmount - card?.balance
            )
    });

    const handleReplenishCard = async values => {
        try {
            await Cards.replenishFunds(cardId, { amount: values.amount });
            dispatch({ type: GET_CARDS });
            setOpen(false);
        } catch (error) {
            console.error(error);
            snackBarRef.current.openSnackBar({
                label: error?.response?.data?.message,
                severity: 'error'
            });
        }
    };

    const handleKeyDown = event => {
        if (event.key === 'Tab') {
            event.stopPropagation();
        }
    };

    return (
        <>
            <Dialog open={open} onKeyDown={handleKeyDown} onClose={() => setOpen(false)} maxWidth="sm" tabIndex="-1">
                <DialogContent>
                    <Typography variant="h6">Replenish Card</Typography>
                    <Typography variant="subtitle1">Enter the amount.</Typography>
                    <Formik
                        initialValues={initialValues}
                        enableReinitialize={true}
                        validationSchema={replenishSchema}
                        onSubmit={handleReplenishCard}>
                        {({ isSubmitting }) => (
                            <Form>
                                <Field
                                    component={TextField}
                                    variant="outlined"
                                    name="amount"
                                    type="text"
                                    size="small"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Typography sx={{ fontSize: '14px', color: 'black' }}>$</Typography>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                                <Typography variant="subtitle1" sx={{ fontSize: '13px' }}>
                                    Limit to replenish:{' '}
                                    <Typography variant="caption" sx={{ fontSize: 12, fontWeight: 500, color: '#000' }}>
                                        {card?.limitAmount - card?.balance}
                                    </Typography>
                                </Typography>
                                <Box display="flex" justifyContent="right" marginTop="15px">
                                    {isSubmitting ? (
                                        <CircularProgress />
                                    ) : (
                                        <Button variant="contained" type="submit">
                                            OK
                                        </Button>
                                    )}
                                </Box>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
            </Dialog>
            <SnackBarComponent ref={snackBarRef} />
        </>
    );
};

export default ReplenishModal;
